<template>
  <footer id="page-footer" class="bg-body-light">
    <div class="content py-3">
        <div class="row font-size-sm">
            <div class="col-sm-6 order-sm-2 py-1 text-center text-sm-right">
                Crafted with <i class="fa fa-heart text-danger"></i> by <a class="font-w600">Portal42</a>
            </div>
            <div class="col-sm-6 order-sm-1 py-1 text-center text-sm-left">
                <a class="font-w600" href="#">GrowTracker 4.1</a> © <span data-toggle="year-copy" class="js-year-copy-enabled">2018-19</span>
            </div>
        </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'Footer',
};
</script>



// WEBPACK FOOTER //
// source/components/Footer.vue